module.exports = __webpack_public_path__ + "static/media/ar.4d01e578.svg";